




























import { defineComponent, ref } from "@nuxtjs/composition-api";
import { ValidationProvider } from "vee-validate";
import { SfHeading } from "@storefront-ui/vue";
import { isEmpty, join } from "lodash-es";
import DatePick from "vue-date-pick";
import "vue-date-pick/dist/vueDatePick.css";

export default defineComponent({
  name: "DatePicker",
  components: {
    DatePick,
    SfHeading,
    ValidationProvider,
  },
  props: {
    option: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    const inputValue = ref("");
    const formatPrice = (option) => {
      return "$" + option.date.price.toFixed(2);
    };
    const rules = ref(
      (() => {
        let rules = [];
        if (props.option.required) {
          rules.push("required");
        }
        return isEmpty(rules) ? "" : join(rules, "|");
      })()
    );
    return {
      rules,
      inputValue,
      formatPrice,
    };
  },
});
